import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { CaptchaDialogComponent } from "@gloria-public/register/views/registration-page/components/captcha-dialog/captcha-dialog.component";
import { EmailConfirmationComponent } from "@gloria-public/register/views/registration-page/components/email-confirmation/email-confirmation.component";
import { CommonTranslateModule } from "@shared/utils/common-translate.module";
import { AppRoutingModule } from "app/app-routing.module";
import { NgxIntlTelInputModule } from "ngx-intl-tel-input";
import { RegistrationPageComponent } from "./registration-page.component";

const materialModules = [MatIconModule, MatSnackBarModule, MatDialogModule, MatProgressSpinnerModule, MatButtonModule];

@NgModule({
  declarations: [RegistrationPageComponent, CaptchaDialogComponent, EmailConfirmationComponent],
  providers: [],
  imports: [
    CommonModule,
    CommonTranslateModule,
    FormsModule,
    ReactiveFormsModule,
    NgxIntlTelInputModule,
    AppRoutingModule,
    ...materialModules,
  ],
})
export class RegistrationPageModule {}
